<svelte:head>
    <title>The Phoenix Pages</title>
</svelte:head>

<script>
	import { onMount } from 'svelte';
    import ShopEditor from '../lib/ShopEditor.svelte';
    import PlaceEditor from '../lib/PlaceEditor.svelte';
    
    let page = 'player';
    
	import { db } from '../api.js';
    let api = {}, selected;
    db.subscribe(val => {
        api = val;
    });

    import { refresh } from '../lib/libs';
    import { toast } from '@zerodevx/svelte-toast';

    async function createNew(type) {
        toast.push('Creating new ' + type.slice(0, -1) + '...', {
            'classes': ['info']
        });

        let newData = {};
        if (type == 'shops') {
            newData = api.blank.shop;
            newData.ShopName = 'Blank Shop';
            newData.ShopOwner = api.player.PlayerUsername;
        } else if (type == 'places') {
            newData = api.blank.place;
            newData.PlaceName = 'Blank Place';
            newData.PlaceOwner = api.player.PlayerUsername;
        } else {
            return;
        };

        await fetch(`https://api.phoenix-pages.izmichael.com/${type}/`, {
            headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8', 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify(newData)
        });

        refresh(type);
        toast.push('Successfully created new ' + type.slice(0, -1) + '!', {
            'classes': ['success']
        });
    }
</script>

<div id="main" class="flex flex-col items-center justify-start flex-1 w-full max-h-full p-6 overflow-hidden">
    <div class="flex flex-row items-center justify-center w-full overflow-hidden rounded-t-lg">
        <button class="flex-1 p-2 text-white bg-yellow-400" on:click={() => page = 'player'}>My Account</button>
        <button class="flex-1 p-2 text-white bg-green-400" on:click={() => page = 'shops'}>My Shops</button>
        <button class="flex-1 p-2 text-white bg-blue-400" on:click={() => page = 'places'}>My Places</button>
    </div>

    <section class="flex-1 w-full max-h-full overflow-hidden flex flex-row justify-start items-center border-yellow-400 p-6 border-8 {page == 'player' ? '' : 'hidden'}">
        <img src="https://mc-heads.net/body/{api.player.PlayerUUID || 'UHF_Steve'}.png" alt="Full Body Render of Skin">
                    
        <div class="flex flex-col items-center justify-start flex-1 h-full">
            <p class="w-full text-2xl">Welcome Back, <b>{api.player.PlayerUsername}</b>.</p>
            <br>
            <p class="w-full mb-2 text-2xl font-bold">Your Statistics:</p>
            <p class="w-full text-2xl">You own: <b>{api.shops.filter(shop => shop.ShopOwner.includes(api.player.PlayerUsername)).length}</b> shops,</p>
            <p class="w-full text-2xl">selling a total of: <b>{api.shops.filter(shop => shop.ShopOwner.includes(api.player.PlayerUsername)).map(a => a.ShopProducts).flat().length}</b> products.</p>
        </div>

        <div class="flex flex-col items-center justify-start flex-1 h-full">
            <button class="w-full p-4 mb-3 text-white bg-green-400 rounded-full shadow-md" on:click={() => createNew('shops')}>Create New Shop</button>
            <button class="w-full p-4 mb-10 text-white bg-blue-400 rounded-full shadow-md" on:click={() => createNew('places')}>Create New Place</button>
        </div>
    </section>
    <section class="flex-1 w-full max-h-full overflow-hidden border-green-400 p-6 border-8 {page == 'shops' ? '' : 'hidden'}">
        <ShopEditor {api}></ShopEditor>
    </section>
    <section class="flex-1 w-full max-h-full overflow-hidden border-blue-400 p-6 border-8 {page == 'places' ? '' : 'hidden'}">
        <PlaceEditor {api}></PlaceEditor>
    </section>
</div>
